import { render, staticRenderFns } from "./SupplyOrders.html?vue&type=template&id=5766678a&external"
import script from "./SupplyOrders.js?vue&type=script&lang=js&external"
export * from "./SupplyOrders.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports